(function () {
    'use strict';
    angular
        .module('app.widgets')
        .directive('obtCalendar', obtCalendar);

    /* @ngInject */
    function obtCalendar () {
        return {
            restrict: 'E', //E = element, A = attribute, C = class, M = comment
            scope: {
                //@ reads the attribute value, = provides two-way binding, & works with functions
                showWeekend: '@',
//                timezone:'@?',
                calendarName : '@?',
                language:'@?',
                calendarFilter: '=?',
                createEvent: '&?',
                resizeEvent: '&?',
                removeEvent: '&?',
                dragEvent: '&?',
                calendarProfile:'=?',
                syncCalendar: '=?', //list of calendar name
                name: '=?', //expose API

                eventClickPromise: '&?',
                renderEventFunction: '&?',
                calendarDataPromise: '&?'
            }, link: function (scope, element, attrs) { //DOM manipulation
                (attrs.showWeekend === 'true' ? scope.showWeekend = true : scope.showWeekend = false);
                (attrs.createEvent ? scope.canCreateEvent = true : scope.canCreateEvent = false);
                (attrs.resizeEvent ? scope.canResizeEvent = true : scope.canResizeEvent = false);
                (attrs.dragEvent ? scope.canDragEvent = true : scope.canDragEvent = false);
                (attrs.removeEvent ? scope.canRemoveEvent = true : scope.canRemoveEvent = false);
                (attrs.renderEventFunction ? scope.useCustomRender = true : scope.useCustomRender = false);
                (attrs.eventClickPromise ? scope.canClickEvent = true : scope.canClickEvent = false);
                (attrs.calendarDataPromise ? scope.canLoadData = true : scope.canLoadData = false);

                scope.calendarName = scope.calendarName ? scope.calendarName : 'calendar';
                    //watch the filter : function(){return scope.calendarFilter},
                scope.$watch('calendarFilter',
                    function (newValue, oldValue) {
                        scope.applyFilters(newValue);
                    }, true);
                scope.setupCalendar();
            },
            template:"<div class=\'calendar\' ng-model=\'eventSources\' ui-calendar=\'uiConfig.calendar\' calendar=\'{{calendarName}}\'\n     ng-style=\"(isCalendarDisabled) ? {\'background\': \'url(\' + disabledCalImg + \') no-repeat center center\', \'background-size\': \'contain\' } : {}\"\n     ng-class=\"{ \'calendar_disabled calendar_loading_bg\' : isCalendarLoadingData, calendar_disabled : isCalendarDisabled }\"></div>",

            controller: /*@ngInject*/function ($scope, $window, calendarService, $compile, logger, $timeout, config, uiCalendarConfig, $sce, $analytics) {
                $scope.eventSources = [];
                $scope.calScrollTime = $scope.calScrollTime || '10:00:00';
                $scope.applyFilters = function (filters) {
                    if (filters) {
                        refetchCalendar();
                    }
                };

                function syncCalendarFct(calendarAPI) {
                    if(calendarAPI){
                        calendarAPI.refetchCalendar();
                    }
                }

                function syncAllCalendarFct() {
                    if ($scope.syncCalendar) {
                        if (angular.isArray($scope.syncCalendar)) {
                            for (var i = 0, size = $scope.syncCalendar.length; i < size; i++) {
                                syncCalendarFct($scope.syncCalendar[i]);
                            }
                        } else if (angular.isObject($scope.syncCalendar)) {
                            syncCalendarFct($scope.syncCalendar);
                        }
                    }
                }

                function refetchAndSync() {
                    refetchCalendar();
                    syncAllCalendarFct();
                }

                function eventMouseoverFn(event, jsEvent, view ){
                    $analytics.eventTrack('hover', {  category: 'calendar', label: event.title });
                }

                //CLICK EVENT//
                //-----------------------------------
                $scope.selectedEvent = false;
                function onEventClick(calEvent) {
                    $analytics.eventTrack('click', {  category: 'calendar', label: calEvent.title });
                    if(calEvent.editable){}
                    if ($scope.canClickEvent && $scope.eventClickPromise && ( angular.isUndefined(calEvent.editable) || calEvent.editable == true)) {
                        $scope.eventClickPromise({calEvent: calEvent, closeCallback: refetchAndSync});
                    }
                }

                function onEventDrop(event, delta, revertFunc, jsEvent, ui, view) {
                    event.start = calendarService.moveDateTimeZone($scope.timezone, event.start);
                    $scope.dragEvent({calEvent: event, closeCallback: refetchAndSync}); //refetchCalendar
                }

                function onEventResize(event, delta, revertFunc, jsEvent, ui, view) {
                    event.end = calendarService.moveDateTimeZone($scope.timezone, event.end);
                    $scope.resizeEvent({calEvent: event, closeCallback: refetchAndSync});
                }

                $scope.onRemoveEvent = function (eventId, eventType) {
                    if ($scope.removeEvent && eventId) {
//                        find the event
                        var calEvent = findEventById(eventId);
                        if (calEvent) {
                            var result = _.find(calEvent, {'type': eventType });
                            if (result) {
                                $scope.removeEvent({calEvent: result, closeCallback: refetchAndSync}); //refetchCalendar});
                            }
                        }
                    }
                };

                //renderEvent fonction call//
                function addTootipOption(event, element, description) {
                    var popRawContent = angular.element('<div class="btn-group" role="group" aria-label="options group">\n    <button type="button" class="btn btn-default"><span class="glyphicon glyphicon-thumbs-up" aria-hidden="true"></span></button>\n    <button type="button" class="btn btn-default"><span class="glyphicon glyphicon-thumbs-down" aria-hidden="true"></span></button>\n</div>\n<div class="btn-group" role="group" aria-label="Close group">\n    <button type="button" class="btn btn-default" ng-click="onRemoveEvent()"><span class="glyphicon glyphicon-remove" aria-hidden="true"></span></button>\n</div>');

                    $scope.$apply(function () {
                        var popContent = $compile(popRawContent)($scope);
                        element.attr("tabindex", event.id);
                        var popoverData = {
                            placement: 'top',
                            html: true,
                            content: description, // popContent,
                            trigger: 'hover focus',
                            delay: {show: 0, hide: 3000}
                        };
                        if (description) {
                            popoverData.title = description;
                        }
                        element.popover(popoverData);
                    });

                    $(document).on('show.bs.popover', function () {
                        $('.popover').not(this).popover('hide');
                    });
                }

                /**
                 *
                 * @param event
                 * @param element
                 * @param functionName the function name to associate with the event
                 * @returns {*}
                 */
                function addCloseEventBtn(event, element, functionName) {

                    //add close button
                    var closeButtonRaw = '<button type="button" ng-click="' + functionName + '(' + event.id + ',' + event.type + ')" obt-stop-event class="close"><span aria-hidden="true" style="font-size: 22px">&times;</span><span class="sr-only">Close</span></button>';
                    var closeButton = angular.element(closeButtonRaw);
                    $compile(closeButton)($scope);
//                    element.find('.fc-title').append(closeButton);
                    element.find('.fc-time').append(closeButton);
                    return closeButton;
                }

                function customEventRender(event, element) {

                    if ($scope.canRemoveEvent && event.isDeletable) {
                        addCloseEventBtn(event, element, 'onRemoveEvent');
                    }
                    if ($scope.useCustomRender && $scope.renderEventFunction) {
                        $scope.renderEventFunction({event: event, element: element});
//                        addTootipOption(event, element);
                    } else {
                        if(!('ontouchstart' in $window))
                        {
                            var tooltip = event.description || event.title || null;
                            tooltip += event.details ?  '<hr class="hrTooltip"><p class="text-left ">' + event.details + '</p>': '';
                            element.tooltip({title:tooltip,container: "body", html:true});
                        }
//                        var trustedHtml = $sce.trustAsHtml(tooltip);
//                        var trustedHtmld = $compile(tooltip)($scope);
//                        element.attr('tooltip-html-unsafe', tooltip );
//                        element.replaceWith($compile(element)($scope));
//                        element.attr("data-title", tooltip);
//                        element.tooltip({container: "body", html:true});
//                        element.attr('tooltip-html-unsafe', '{{"tooltip"}}');
//                       addTootipOption(event, element, tooltip);
                    }
                }

                // I load the "remote" data from the server.
                function renderCalendar() {
                    if (uiCalendarConfig.calendars[$scope.calendarName]) {
                        $timeout(function render(){
                            console.log('render calendar called');
                            uiCalendarConfig.calendars[$scope.calendarName].fullCalendar('render');
                        }, 0);
                    }
                }
                function refetchCalendar() {
                    if (uiCalendarConfig.calendars[$scope.calendarName]) {
                        uiCalendarConfig.calendars[$scope.calendarName].fullCalendar('unselect');
                        uiCalendarConfig.calendars[$scope.calendarName].fullCalendar('refetchEvents');
                    }
                }

                $scope.name = {refetchCalendar: refetchCalendar, renderCalendar:renderCalendar};

                function createEventClick(date, endDate) {
                    if ($scope.canCreateEvent && $scope.createEvent) {
                        var newEvent = {};
//                        newEvent.title = 'test';
                        newEvent.start = date;
                        if ($scope.timezone) { //set time zone
                            calendarService.moveDateTimeZone($scope.timezone, newEvent.start);
                        }

                        if (endDate) {
                            newEvent.end = endDate;
                            if ($scope.timezone) { //set time zone
                                calendarService.moveDateTimeZone($scope.timezone, newEvent.end);
                            }
                        } else {
                            newEvent.end = angular.copy(newEvent.start);
                            newEvent.end.add(30, 'minutes');
                        }

                        if($scope.calendarFilter ){
                            newEvent.therapistId = $scope.calendarFilter.therapistId;
                        }

                        //create a new event pass it to the custum function
                        $scope.createEvent({calEvent: newEvent, closeCallback: refetchAndSync});
                    }
                }

                function setBusinessHour(data){
                    uiCalendarConfig.calendars[$scope.calendarName].fullCalendar('businessHours ', data.businessHours);
                }
                function setdefaultDate(startDate) {
                    uiCalendarConfig.calendars[$scope.calendarName].fullCalendar('gotoDate', startDate);
                }

                function changeCalendarView(viewName) {
                    if (viewName) {
                        uiCalendarConfig.calendars[$scope.calendarName].fullCalendar('changeView', viewName);
                    }
                }

                function findEventById(eventId) {
                    if (eventId) {
                        return getEvents(eventId);
                    }
                }

                function getEvents(eventId) {
                    if (eventId) {
                        return uiCalendarConfig.calendars[$scope.calendarName].fullCalendar('clientEvents', eventId);
                    } else {
                        return uiCalendarConfig.calendars[$scope.calendarName].fullCalendar('clientEvents'); //return all events
                    }
                }

                $scope.setupCalendar = function getProfileAndSetupCalendar(){
                    if($scope.calendarProfile){
                        setupCalendar($scope.calendarProfile);
                    }else{
                        setupCalendar();
                    }
                };

                function replaceEvents(newEventList) {
                    //clear event
                    uiCalendarConfig.calendars[$scope.calendarName].fullCalendar('removeEvents');
                    //add new events
                    for (var i = 0; i < newEventList.length; i++) {
                        uiCalendarConfig.calendars[$scope.calendarName].fullCalendar('renderEvent', newEventList[i]);
                    }
                }

                function setupCalendar(profile) {
                    profile = profile || {};

                    console.log('--------- calendar profile ------------');
                    console.log(profile);

                    profile.showWeekend = profile.showWeekend || false;
                    profile.viewBasic = profile.viewBasic || profile.viewBasic !== false;
                    profile.scrollTime = profile.scrollTime || '10:00:00';
                    profile.viewHeight = profile.height || profile.viewHeight || 300;
                    profile.viewMonth = profile.viewMonth || false;
                    profile.viewWeek = profile.viewWeek || false;
                    profile.viewTreeDay = profile.viewTreeDay || false;
                    profile.viewDay = profile.viewDay || false;
                    profile.timeFormat =  profile.timeFormat || 'H:mm';
                    profile.businessHours = profile.businessHours ||  {};
                    profile.isCalendarDisabled = profile.isCalendarDisabled || false;  //define if the calendar is disabled for this session

                    $scope.isCalendarDisabled = profile.isCalendarDisabled;
                    $scope.isCalendarLoadingData = false;
                    $scope.disabledCalImg = profile.disabledCalImg || config.calendarDisabledImage;

                    var dayView = profile.viewBasic ? 'basicDay': 'agendaDay';
                    var weekView = profile.viewBasic ? 'basicWeek': 'agendaWeek';
//                    var rightMenu =  weekView + ',' +dayView;
                    var rightMenu = "";
                    rightMenu = profile.viewDay ? dayView + ',' + rightMenu: rightMenu;
                    rightMenu = profile.viewTreeDay ? 'basicThreeDays,' + rightMenu: rightMenu;
                    rightMenu = profile.viewWeek ? weekView +',' + rightMenu: rightMenu;
                    rightMenu = profile.viewMonth ? 'month,'+ rightMenu : rightMenu;

                    profile.defaultView = profile.viewName || profile.defaultView  ||  weekView;

                    var header = {
                        left: 'prev,next',
                        right: profile.headerRight || rightMenu
                    };
                    if(!profile.hideToday){
                        header.left +=' today';
                    }
                    if(!profile.hideTitle){
                        header.center = 'title'
                    }


                    $scope.uiConfig = {
                        calendar: {
                            columnFormat:'ddd D MMM',
                            timezone:false,
                            timeFormat:profile.timeFormat,
                            height: profile.viewHeight,
                            editable: false,
                            weekends: profile.defaultView == 'basicThreeDays' || profile.viewTreeDay ? true : profile.showWeekend,
                            defaultView: profile.defaultView,
                            scrollTime: profile.scrollTime,
                            header: header,
                            eventLimit: true, // allow "more" link when too many events
                            handleWindowResize: true,
                            windowResize: function(view) {
                                if(profile.viewMonth && profile.viewWeek && profile.viewTreeDay && profile.viewDay ){
                                    if ($window.innerWidth < 514) {
                                        changeCalendarView(dayView);
                                    } else {
                                        changeCalendarView(weekView);
                                    }
                                }

                            },
                            businessHours: profile.businessHours,

                            views: {
                                basicThreeDays: {
                                    type: 'basicDay', /*basicWeek*/
                                    duration: { days: 3 },
                                    buttonText: '3 days'
//                                    start: $.fullCalendar.moment(startSemester)
//                                    end: $.fullCalendar.moment(endSemester),
//                                    intervalStart: $.fullCalendar.moment(startSemester),
//                                    intervalEnd: $.fullCalendar.moment(endSemester),
                                }
                            },

                            selectable: $scope.canCreateEvent,
                            selectHelper: $scope.canCreateEvent,
                            unselectAuto:true,
                            select: function (start, end) {
                                createEventClick(start, end);
                            },
                            eventStartEditable: $scope.canDragEvent, //drag
                            eventDurationEditable: $scope.canResizeEvent, //resize
                            lang: $scope.language || config.language,
                            allDayDefault: false, //events can be display on the agenda view
                            eventClick: function (calEvent, jsEvent, view) {
                                onEventClick(calEvent);
                            },
                            eventMouseover : function (event, jsEvent, view ) {
                                eventMouseoverFn(event, jsEvent, view);
                            },
                            eventRender: function (event, element) {
                                customEventRender(event, element);
                            },
                            eventDrop: function (event, delta, revertFunc, jsEvent, ui, view) {
                                onEventDrop(event, delta, revertFunc, jsEvent, ui, view);
                            },
                            eventResize: function (event, delta, revertFunc, jsEvent, ui, view) {
                                onEventResize(event, delta, revertFunc, jsEvent, ui, view);
                            },
//                            eventSources: [{
                                events: function (start, end, timezone, callback) {
                                    if (!profile.isCalendarDisabled  && $scope.canLoadData && $scope.calendarDataPromise) {
                                        $scope.isCalendarLoadingData = true;
                                        var promise = $scope.calendarDataPromise({start: start, end: end});
                                        promise.then(function (calData) {
                                            var profile = null,
                                                events = [],
                                                timezone;

                                            timezone = calData.timezone;
                                            if(calData.data && calData.data.profile){
                                                profile = calData.data.profile;
                                                events = calData.data.data;
                                            }else{
                                                events = calData.data;
                                            }
                                            if (events && events[0]) {
                                                $scope.calendarDataToLoad = events;
                                                //if(events[0].start < end){
                                                    setdefaultDate(events[0].start);
                                                //}
                                            }
                                            if(profile){
                                                setBusinessHour(profile);
                                            }
                                            if(events){
                                                callback(events);
                                            }
                                            $scope.timezone = timezone;
                                            $scope.isCalendarLoadingData = false;
                                        }, function (data) {
                                            if (data && angular.isString(data.body)) {
                                                if (data.error != 0) {
                                                    logger.error(data.body);
                                                }
                                            }
                                            $scope.isCalendarLoadingData = false;
                                        });
                                    }
                                }
//                            }]
                        }
                    };
                }
            }
        }
    }})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/obt-Calendar.directive.js
 ** module id = 182
 ** module chunks = 0
 **/